import React, { FC, useMemo } from 'react';
import { View } from 'api/views/types';
import { Filter } from 'components/molecules/filters/types';
import {
  FilterPopover,
  SavedViews as ViewsComponent,
} from 'components/molecules/views';
import { FilterableField } from 'components/organisms/tasks/fields';
import { useTranslation } from 'hooks/use-translation';
import { DEFAULT_VIEW_ID, getDefaultViews } from './default-view';
import { TimesheetReportViewDefinition } from './types';
import { useTimesheetOverallReportViews } from './use-views';
import {
  getFilterEditorPopoverComponents,
  isValidViewDefinition,
  viewDefinitionComparator,
} from './utils';

interface Props {
  fieldLookup: Record<string, FilterableField>;
  isFieldsLoading: boolean;
  currentDefinition: TimesheetReportViewDefinition;
  currentViewId?: number;
  fields: FilterableField[];
  onViewSelect: (view: View<TimesheetReportViewDefinition>) => void;
  onFilterChange: (filter: Filter) => void;
}

export const TimesheetReportViews: FC<Props> = ({
  currentViewId,
  currentDefinition,
  fields,
  isFieldsLoading,
  onViewSelect,
  onFilterChange,
  fieldLookup,
}) => {
  const allProjectsText = useTranslation(
    'resource_management.views.all_projects',
  );
  const defaultViews = useMemo(
    () => getDefaultViews(allProjectsText),
    [allProjectsText],
  );
  const { onViewCreate, onViewDelete, onViewUpdate, views } =
    useTimesheetOverallReportViews({ fieldLookup, isFieldsLoading });

  return (
    <ViewsComponent
      filterComponent={
        <FilterPopover
          filter={currentDefinition.filter}
          fields={fields}
          loading={isFieldsLoading}
          onChange={onFilterChange}
          getSelectEditorComponents={getFilterEditorPopoverComponents}
        />
      }
      views={views}
      defaultViewsList={defaultViews}
      defaultViewId={DEFAULT_VIEW_ID}
      currentViewDefinition={currentDefinition}
      onViewSelect={onViewSelect}
      isValidViewDefinition={isValidViewDefinition}
      viewDefinitionComparator={viewDefinitionComparator}
      onViewCreate={onViewCreate}
      onViewDelete={onViewDelete}
      onViewUpdate={onViewUpdate}
      selectedViewId={currentViewId ?? DEFAULT_VIEW_ID}
    />
  );
};
